import React from 'react'

function Titles() {
    return (
        <>
            <div className="titles-container"> 
                <h4 className="bold prod">Producto</h4>
                <h4 className="bold cant">Cant.</h4>
                <h4 className="bold unit">P. Unit</h4>
                <h4 className="bold">P. Total</h4>
            </div>
            <hr className="solid" />
        </>
    )
}

export default Titles 